<template>
  <div class="expander" :class="{expanded: expanded}">
    <div style="width: 100%">
      <div class="header" @click="expanded = !expanded">
        <div class="indicator" @click="expanded = !expanded"></div>
        <div class="title">
          <h2>
            <slot name="title"></slot>
          </h2>
          <div class="subtitle">
            <slot name="subtitle"></slot>
          </div>
        </div>
        <div class="tags">
          <slot name="tags"/>
        </div>
      </div>
      <div class="details">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        expanded: false
      }
    }
  }
</script>


<style scoped lang="scss">
  $colorMain: #1976d2;
  $colorAccent: #fdd835;
  .expander {
    background: rgba(black, 0.6);
    color: white;
    border-radius: 8px;
    border: 4px solid $colorAccent;
    display: flex;
    margin: 10px 0;
    overflow: hidden;
    justify-content: stretch;
    box-shadow: 0 2px 6px rgba(#000, 0.4);
    transition: transform 240ms ease-in-out;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      transform: scale(1.02);
    }

    .header {
      transition: padding-bottom 240ms ease;
      display: flex;
      cursor: pointer;
      padding: 20px;
      background: $colorAccent;
      color: black;

      .material-icons {
        flex-shrink: 0;
        font-size: 30px;
      }

      h2 {
        margin: 0;
      }

      .title {
        flex-grow: 1;
        width: 100%;
      }

      .tags {
        display: block;
        text-align: right;
      }
    }

    .details {
      max-height: 0;
      opacity: 0;
      transition: max-height 240ms ease, padding-top 240ms ease;
      position: relative;

      &:after {
        content: "";
        position: absolute;
        top: -4px;
        left: -4px;
        bottom: -4px;
        right: -4px;
        border: 4px solid $colorAccent;
        border-radius: 8px;
        z-index: -1;
      }
    }

    .indicator {
      cursor: pointer;
      position: relative;
      width: 30px;
      flex-shrink: 0;

      &:before, &:after {
        content: '';
        display: block;
        background: black;
        width: 2px;
        height: 10px;
        position: absolute;
        left: 5px;
        top: 1em;
        transform: rotate(0deg);
        transition: all 240ms ease;
      }

      &:after {
        transform: rotate(90deg);
      }
    }

    &.expanded {
      .title {
        padding-bottom: 10px;
      }

      .details {
        padding-top: 20px;
        max-height: 1000px;
        opacity: 1;
        padding: 20px;
      }

      .indicator {
        color: $colorMain;
        margin-bottom: 1em;

        &:before {
          transform: rotate(90deg);
        }
      }
    }
  }
</style>
